import { DataBean } from "../DataBean";

export class MessageTemplate extends DataBean {
    
    public async getMessageTemplateCatalogPorPropiedad(nombrePropiedad:any,value:any,maxRows:any): Promise<any> {
        return this.getCustomService("BpmService", "java.util.List_getMessageTemplateCatalogPorPropiedad_String_Object_Number", [nombrePropiedad,value,maxRows]);
    }

}